import { render } from "./checkbox.vue?vue&type=template&id=45666224&scoped=true"
import script from "./checkbox.vue?vue&type=script&lang=js"
export * from "./checkbox.vue?vue&type=script&lang=js"

import "./checkbox.vue?vue&type=style&index=0&id=45666224&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2729008182/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45666224"]])

export default __exports__